import { call, put, select, takeLatest } from 'redux-saga/effects';
import { IpaUserExtended } from '../../../shared/sagas/auth/authSlice';
import { AxiosResponse } from 'axios';
import { selectCurrentUser } from '../../../shared/sagas/auth/authSlice';
import {
  PmsApi,
  Configuration,
  PayerTypeSearchParamsDto,
  CreateOwnerDto,
  CreatePaymentRequestDto,
  PayerDto,
  PaymentRequestDto,
  PaymentRequestSearchDTO,
  ResendPaymentRequestDto,
  PaymentRequestDetailDto,
  PaymentsApi,
  FeesDTO,
  BankCardTypeDto,
  CreateOneTimePaymentDto,
  TransactionDTO,
  BankCardsApi,
  OwnersApi,
  ApplicationsV1Api,
  CreateApplicationOccupantDto,
  CreatePaymentRequestResponseDto,
} from '@inosio/payments-sdk';
import {
  getApplicantsList,
  getCreateApplicant,
  getCreateOwner,
  getCreatePaymentRequest,
  getPaymentRequestData,
  getPaymentRequestDetail,
  getResendRequest,
  getPaymentRequestBalanceDetail,
  setApplicantsList,
  setCreateApplicant,
  setCreateOwner,
  setCreatePaymentRequest,
  setPaymentRequestData,
  setPaymentRequestDetail,
  setPaymentRequestDetailError,
  setPaymentRequestError,
  setResendRequest,
  setResendRequestError,
  setPaymentRequestBalanceDetail,
  getPaymentRequestFees,
  setPaymentRequestFees,
  FeeParamsDto,
  getBankCardTypeByPrefix,
  setBankCardTypeByPrefix,
  setBankCardTypeError,
  getMakePaymentRequestOtp,
  setMakePaymentRequestOtp,
  setMakePaymentRequestOtpError,
  getPaymentRequestStatusType,
  setPaymentRequestStatusType,
  setPaymentRequestStatusError,
  PrStatusTypeDto,
  CancelTransactionByPayerUuidDto,
  getCancelTransaction,
  setCancelTransaction,
  setCancelTransactionError,
} from './paymentrequestslice';

const { REACT_APP_IPA_BASE_PATH } = process.env;
const apiConfig = new Configuration({ basePath: REACT_APP_IPA_BASE_PATH });

export function requestCreateApplicant(access_token: string, addApplicantDto: CreateApplicationOccupantDto) {
  apiConfig.accessToken = access_token;
  const ipaPmAPI = new ApplicationsV1Api(apiConfig);

  return ipaPmAPI.createApplicant(addApplicantDto);
}

export function requestFindPaymentRequest(access_token: string, paymentrequestsearchdto: PaymentRequestSearchDTO) {
  apiConfig.accessToken = access_token;
  const ipaPaymentsAPI = new PaymentsApi(apiConfig);

  return ipaPaymentsAPI.searchPaymentRequestsByPM(paymentrequestsearchdto);
}

export function requestResendPaymentRequest(access_token: string, paymentRequestUuid: string, resendrequestdto: ResendPaymentRequestDto) {
  apiConfig.accessToken = access_token;
  const ipaPaymentsAPI = new PaymentsApi(apiConfig);

  return ipaPaymentsAPI.resendPaymentRequest(paymentRequestUuid, resendrequestdto);
}

export function requestPaymentRequestDetail(access_token: string, request_uuid: string) {
  apiConfig.accessToken = access_token;
  const ipaPaymentsAPI = new PaymentsApi(apiConfig);
  return ipaPaymentsAPI.getPaymentRequestDetails(request_uuid);
}

export function requestPaymentRequestBalanceDetail(request_uuid: string) {
  const ipaPaymentsAPI = new PaymentsApi(apiConfig);
  return ipaPaymentsAPI.getPaymentRequestBalanceDetails(request_uuid);
}

export function requestPaymentRequestFees(FeeParams: FeeParamsDto) {
  const ipaPaymentsAPI = new PaymentsApi(apiConfig);
  return ipaPaymentsAPI.getPaymentFees(FeeParams.PayerUUID, FeeParams.PaymentAmount, FeeParams.PropPayTypeId, FeeParams.PaymentRequestId);
}

export function requestBankCardTypeByPrefix(cardPrefix: string) {
  const ipaBankCardsAPI = new BankCardsApi(apiConfig);
  return ipaBankCardsAPI.getBankCardTypeByBIN(cardPrefix);
}

export function requestCreateOwner(access_token: string, createOwnerDto: CreateOwnerDto) {
  apiConfig.accessToken = access_token;
  const ipaOwnersAPI = new OwnersApi(apiConfig);

  return ipaOwnersAPI.createOwner(createOwnerDto);
}

export function requestCreatePaymentRequest(access_token: string, AddPaymentRequestDto: CreatePaymentRequestDto) {
  apiConfig.accessToken = access_token;
  const ipaPaymentsAPI = new PaymentsApi(apiConfig);

  return ipaPaymentsAPI.createPaymentRequest(AddPaymentRequestDto);
}

export function requestGetPayersList(access_token: string, pmUuid: string, PayerSearchDto: PayerTypeSearchParamsDto) {
  apiConfig.accessToken = access_token;
  const ipaPmAPI = new PmsApi(apiConfig);

  return ipaPmAPI.searchPayerByName(pmUuid, PayerSearchDto);
}

export function requestMakePaymentRequestPrOtpDto(createOneTimePaymentDto: CreateOneTimePaymentDto) {
  const ipaPaymentsAPI = new PaymentsApi(apiConfig);
  return ipaPaymentsAPI.createOneTimePayment(createOneTimePaymentDto);
}

export function requestPaymentRequestStatusType(access_token: string, PrStatusType: PrStatusTypeDto) {
  apiConfig.accessToken = access_token;
  const ipaPaymentsAPI = new PaymentsApi(apiConfig);
  return ipaPaymentsAPI.changePaymentRequestStatus(PrStatusType.requestUuid, PrStatusType.statusDescription);
}

export function requestCancelTransaction(CancelTransactionDto: CancelTransactionByPayerUuidDto) {
  const ipaPaymentsAPI = new PaymentsApi(apiConfig);
  return ipaPaymentsAPI.cancelTransactionByPayerUuid(CancelTransactionDto.transactionUuid, CancelTransactionDto.payerUuid);
}

export function* handleGetCreateApplicant(action: { type: typeof getCreateApplicant; payload: CreateApplicationOccupantDto }) {
  try {
    const currentUser: IpaUserExtended = yield select(selectCurrentUser);
    const response: AxiosResponse<PayerDto> = yield call(requestCreateApplicant, currentUser.accessToken, action.payload);
    const { data } = response;
    yield put(setCreateApplicant(data));
  } catch (error: any) {
    if (error?.response?.data) {
      yield put(setPaymentRequestError({ message: error?.response?.data?.message }));
    } else {
      yield put(setPaymentRequestError({ ...error }));
    }
  }
}

export function* handleGetCreateOwner(action: { type: typeof getCreateOwner; payload: CreateOwnerDto }) {
  try {
    const currentUser: IpaUserExtended = yield select(selectCurrentUser);
    const response: AxiosResponse<PayerDto> = yield call(requestCreateOwner, currentUser.accessToken, action.payload);
    const { data } = response;
    yield put(setCreateOwner(data));
  } catch (error: any) {
    if (error?.response?.data) {
      yield put(setPaymentRequestError({ message: error?.response?.data?.message }));
    } else {
      yield put(setPaymentRequestError({ ...error }));
    }
  }
}

export function* handleGetCreatePaymentRequest(action: { type: typeof getCreatePaymentRequest; payload: CreatePaymentRequestDto }) {
  try {
    const currentUser: IpaUserExtended = yield select(selectCurrentUser);
    const response: AxiosResponse<CreatePaymentRequestResponseDto> = yield call(requestCreatePaymentRequest, currentUser.accessToken, action.payload);
    const { data } = response;
    yield put(setCreatePaymentRequest(data));
  } catch (error: any) {
    if (error?.response?.data) {
      yield put(setPaymentRequestError({ message: error?.response?.data?.message }));
    } else {
      yield put(setPaymentRequestError({ ...error }));
    }
  }
}

export function* handleGetApplicantsList(action: { type: typeof getApplicantsList; payload: PayerTypeSearchParamsDto }) {
  try {
    const currentUser: IpaUserExtended = yield select(selectCurrentUser);
    const response: AxiosResponse<PayerDto[]> = yield call(requestGetPayersList, currentUser.accessToken, currentUser.currentProfile.uuid, action.payload);
    const { data } = response;
    yield put(setApplicantsList(data));
  } catch (error: any) {
    if (error?.response?.data) {
      yield put(setPaymentRequestError({ message: error?.response?.data?.message }));
    } else {
      yield put(setPaymentRequestError({ ...error }));
    }
  }
}

export function* handleGetPaymentRequest(action: { type: typeof getPaymentRequestData; payload: PaymentRequestSearchDTO }) {
  try {
    const currentUser: IpaUserExtended = yield select(selectCurrentUser);
    const response: AxiosResponse<PaymentRequestDto> = yield call(requestFindPaymentRequest, currentUser.accessToken, action.payload);
    const { data } = response;

    yield put(setPaymentRequestData(data));
  } catch (error: any) {
    if (error?.response?.data) {
      yield put(
        setPaymentRequestError({
          message: error?.response?.data?.message,
          statusCode: error?.response?.data?.statusCode,
        }),
      );
    } else {
      yield put(setPaymentRequestError({ ...error }));
    }
  }
}

export function* handleGetResendRequest(action: { type: typeof getPaymentRequestData; payload: { PayerEmail: string; PaymentRequestId: string } }) {
  try {
    const currentUser: IpaUserExtended = yield select(selectCurrentUser);
    yield call(requestResendPaymentRequest, currentUser.accessToken, action.payload.PaymentRequestId, { PayerEmail: action.payload.PayerEmail } as ResendPaymentRequestDto);

    yield put(setResendRequest());
  } catch (error: any) {
    if (error?.response?.data) {
      yield put(setResendRequestError({ message: error?.response?.data?.message }));
    } else {
      yield put(setResendRequestError({ ...error }));
    }
  }
}

export function* handleGetPaymentRequestDetail(action: { type: typeof getPaymentRequestDetail; payload: string }) {
  try {
    const currentUser: IpaUserExtended = yield select(selectCurrentUser);
    const response: AxiosResponse<PaymentRequestDetailDto> = yield call(requestPaymentRequestDetail, currentUser.accessToken, action.payload);
    const { data } = response;
    yield put(setPaymentRequestDetail(data));
  } catch (error: any) {
    if (error?.response?.data) {
      yield put(setPaymentRequestDetailError({ message: error?.response?.data?.message }));
    } else {
      yield put(setPaymentRequestDetailError({ ...error }));
    }
  }
}

export function* handleGetPaymentRequestBalanceDetail(action: { type: typeof getPaymentRequestBalanceDetail; payload: string }) {
  try {
    const response: AxiosResponse<PaymentRequestDetailDto> = yield call(requestPaymentRequestBalanceDetail, action.payload);
    const { data } = response;
    yield put(setPaymentRequestBalanceDetail(data));
  } catch (error: any) {
    if (error?.response?.data) {
      yield put(setPaymentRequestDetailError({ message: error?.response?.data?.message }));
    } else {
      yield put(setPaymentRequestDetailError({ ...error }));
    }
  }
}

export function* handleGetPaymentRequestFees(action: { type: typeof getPaymentRequestFees; payload: FeeParamsDto }) {
  try {
    const response: AxiosResponse<FeesDTO> = yield call(requestPaymentRequestFees, action.payload);
    const { data } = response;
    yield put(setPaymentRequestFees(data));
  } catch (error: any) {
    if (error?.response?.data) {
      yield put(setPaymentRequestDetailError({ message: error?.response?.data?.message }));
    } else {
      yield put(setPaymentRequestDetailError({ ...error }));
    }
  }
}

export function* handlePaymentRequestStatusType(action: { type: typeof getPaymentRequestStatusType; payload: PrStatusTypeDto }) {
  try {
    const currentUser: IpaUserExtended = yield select(selectCurrentUser);
    const response: AxiosResponse<void> = yield call(requestPaymentRequestStatusType, currentUser.accessToken, action.payload);
    const { data } = response;
    yield put(setPaymentRequestStatusType(data));
  } catch (error: any) {
    if (error?.response?.data) {
      yield put(setPaymentRequestStatusError({ message: error?.response?.data?.message }));
    } else {
      yield put(setPaymentRequestStatusError({ ...error }));
    }
  }
}

export function* handleMakePaymentRequestPrOtpDto(action: { type: typeof getMakePaymentRequestOtp; payload: CreateOneTimePaymentDto }) {
  try {
    const response: AxiosResponse<TransactionDTO> = yield call(requestMakePaymentRequestPrOtpDto, action.payload);
    const { data } = response;
    yield put(setMakePaymentRequestOtp(data));
  } catch (error: any) {
    if (error?.response?.data) {
      yield put(setMakePaymentRequestOtpError({ message: error?.response?.data?.message }));
    } else {
      yield put(setMakePaymentRequestOtpError({ ...error }));
    }
  }
}

export function* handleGetCancelTransaction(action: { type: typeof getCancelTransaction; payload: CancelTransactionByPayerUuidDto }) {
  try {
    yield call(requestCancelTransaction, action.payload);
    yield put(setCancelTransaction());
  } catch (error: any) {
    if (error?.response?.data) {
      yield put(setCancelTransactionError({ message: error?.response?.data?.message }));
    } else {
      yield put(setCancelTransactionError({ ...error }));
    }
  }
}

export function* handleGetBankCardType(action: { type: typeof getBankCardTypeByPrefix; payload: { cardPrefix: string } }) {
  try {
    const response: AxiosResponse<BankCardTypeDto> = yield call(requestBankCardTypeByPrefix, action.payload.cardPrefix);
    const { data } = response;
    yield put(setBankCardTypeByPrefix(data));
  } catch (error: any) {
    if (error?.response?.data) {
      yield put(setBankCardTypeError({ message: error?.response?.data?.message }));
    } else {
      yield put(setBankCardTypeError({ ...error }));
    }
  }
}

export function* paymentRequestsSaga() {
  yield takeLatest(getCreateApplicant.type, handleGetCreateApplicant);
  yield takeLatest(getCreateOwner.type, handleGetCreateOwner);
  yield takeLatest(getApplicantsList.type, handleGetApplicantsList); //may no longer need this
  yield takeLatest(getCreatePaymentRequest.type, handleGetCreatePaymentRequest);
  yield takeLatest(getPaymentRequestData.type, handleGetPaymentRequest);
  yield takeLatest(getResendRequest.type, handleGetResendRequest);
  yield takeLatest(getPaymentRequestDetail.type, handleGetPaymentRequestDetail);
  yield takeLatest(getPaymentRequestBalanceDetail.type, handleGetPaymentRequestBalanceDetail);
  yield takeLatest(getPaymentRequestFees.type, handleGetPaymentRequestFees);
  yield takeLatest(getBankCardTypeByPrefix.type, handleGetBankCardType);
  yield takeLatest(getMakePaymentRequestOtp.type, handleMakePaymentRequestPrOtpDto);
  yield takeLatest(getPaymentRequestStatusType.type, handlePaymentRequestStatusType);
  yield takeLatest(getCancelTransaction.type, handleGetCancelTransaction);
}
